export const getRepaymentSchedule = (state, account) => {
    const scheduledPayments = account?.scheduled_payments ?? null;
    return scheduledPayments
        ? scheduledPayments
        : state?.iwocapayDashboard?.selectedPlan?.schedule ?? {};
};

export const getNextRepayment = (state, account) => {
    return getRepaymentSchedule(state, account).schedule[0];
};

export const getTotalPrincipleFromSchedule = (state, account) => {
    const { schedule } = getRepaymentSchedule(state, account);

    const totalPrinciple = schedule.reduce(
        (total, schedule) => total + schedule.principal,
        0
    );

    return totalPrinciple;
};

export const getTotalInterestFromSchedule = (state, account) => {
    const { schedule } = getRepaymentSchedule(state, account);

    const totalInterest = schedule.reduce(
        (total, schedule) => total + schedule.interest,
        0
    );

    return totalInterest;
};
